import { ParamMap } from '@angular/router';
import { AccessLevel, AssetType } from '../services/asset-service/types';
import { AssetFilters } from './types';

export const parseUrlToAssetFilters = (params: ParamMap): AssetFilters => {
  return {
    search_text: params.get('search_text') ?? '',

    // params.getAll() safely collects repeating keys (?sector=A&sector=B) into an array
    asset_type: (params.getAll('asset_type') as AssetType[]) ?? [],
    trust_status: params.getAll('trust_status') ?? [],
    access: (params.getAll('access') as AccessLevel[]) ?? [],
    sector: params.getAll('sector') ?? [],
    themes: params.getAll('themes') ?? [],
    regions: params.getAll('regions') ?? [],
  };
};
